// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MetricModalHolder, {
    Stats,
    Indicator,
    IndicatorProgress,
    IndicatorGoal,
} from './MetricModal.style';

const MetricModal = ({ metric, forAdmin, customCta }) => {
    const [showCta, setShowCta] = useState(false);

    const {
        minimum_value,
        maximum_value,
        goal,
        overall_score,
        overall_metric,
        result,
        inversed,
    } = metric;

    const value = forAdmin ? overall_score : result;
    const interval = maximum_value - minimum_value;
    const scoring = Math.min(
        Math.round(((value - minimum_value) / interval) * 100),
        100
    );
    const required = Math.min(
        Math.round(((goal - minimum_value) / interval) * 100),
        100
    );
    const efficient = inversed ? scoring <= required : scoring >= required;

    return (
        <MetricModalHolder
            onFocus={() => setShowCta(true)}
            onMouseOver={() => setShowCta(true)}
            onBlur={() => setShowCta(false)}
            onMouseLeave={() => setShowCta(false)}
            overall={!!overall_metric}
        >
            <strong>{metric.name}</strong>
            <span>{metric.description || 'No description'}</span>

            {customCta && showCta ? (
                customCta(setShowCta)
            ) : (
                <Stats>
                    <Indicator>
                        <IndicatorProgress
                            scoring={scoring}
                            efficient={efficient}
                        >
                            <span>{value}</span>
                        </IndicatorProgress>
                        <IndicatorGoal goal={required}>
                            <span>
                                {inversed && '←'}
                                {goal}
                                {!inversed && '→'}
                            </span>
                        </IndicatorGoal>
                    </Indicator>
                    <span>Goal:</span>
                </Stats>
            )}
        </MetricModalHolder>
    );
};

MetricModal.propTypes = {
    customCta: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
    metric: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        minimum_value: PropTypes.number.isRequired,
        maximum_value: PropTypes.number.isRequired,
        goal: PropTypes.number.isRequired,
        enabled: PropTypes.bool.isRequired,
        inversed: PropTypes.bool.isRequired,
        overall_score: PropTypes.number.isRequired,
        overall_metric: PropTypes.bool.isRequired,
        result: PropTypes.number.isRequired,
    }).isRequired,
    forAdmin: PropTypes.bool,
};

MetricModal.defaultProps = {
    customCta: undefined,
    forAdmin: false,
};

export default MetricModal;
